export default __webpack_public_path__ + "static/media/dot-delegate.196a7737.svg";